<script setup lang="ts">
import type { PressPage } from 'storyblok/types/pages'

const page = ref(1)
const tabIdx = ref(0)

interface PressArticleItem {
  slug: string
  content: {
    title: string
    publishDate: Date
    perex: StoryBlokRichText
    pdfButton?: StoryBlokButton[]
    zipButton?: StoryBlokButton[]
  }
}

const sbApi = useStoryblokApiV2()
const data: StoryblokPage = await sbApi.getPage()

const mediaData: StoryblokPage = await sbApi.getPage('/pro-media')
const mediaPage = mediaData.customPage[0] as PressPage

const { data: articles } = await useAsyncData(`getArticles${page.value}`, () => sbApi.getStories<PressArticleItem>({
  by_slugs: ['pages/press/*'],
  sort_by: 'content.publishDate:desc',
  per_page: 100,
  is_startpage: false,
  page: page.value,
}), {
  watch: [page],
})

useStoryblokMeta(data)

const tabItems = computed(() => {
  if (!articles.value) return []
  const years = articles.value.stories.map((articles) => {
    return new Date(articles.content.publishDate).getFullYear()
  })
  return [...new Set(years)].sort((a, b) => b - a).map(year => (year.toString()))
})

const filteredArticles = computed(() => {
  if (!articles.value) return []
  return articles.value.stories.filter((articles) => {
    return new Date(articles.content.publishDate).getFullYear() === +(tabItems.value[tabIdx.value])
  })
})
</script>

<template>
  <div>
    <header class="bg-gradient text-center pt-5 pb-10">
      <div class="content-container">
        <AppBreadcrumbs />
        <h1 class="mt-5">
          {{ data.title }}
        </h1>
      </div>
    </header>
    <div class="bg-background">
      <div class="max-w-1080px pt-10 flex flex-col gap-5 content-container">
        <BaseTabs v-model="tabIdx" :items="tabItems" />
        <PressArticle v-for="{ slug, content: article } in filteredArticles" :key="slug" :slug="slug" v-bind="article" />
      </div>
      <PressContact v-bind="mediaPage" />
    </div>
  </div>
</template>
